const { default: Styled } = require('styled-components');
const { transient$Props } = require('utils/styles');

const APP_SHELL_CONTENT_MAX_WIDTH = 600;
const APP_SHELL_CONTENT_PADDING_X = 'clamp(16px, 5vw, 32px)';
const APP_SHELL_CONTENT_PADDING_Y = 24;
const APP_SHELL_CONTENT_PADDING_BOTTOM = 40;

const internals = {};

internals.AppShellContent = Styled('main', transient$Props).attrs({
    id: 'main-content'
})`
    width: 100%;
    max-width: ${({ $fullWidth }) => $fullWidth ? 'none' : `${APP_SHELL_CONTENT_MAX_WIDTH}px`};
    margin: 0 auto;
    flex-grow: 1;
    background-color: white;
    position: relative;
    padding: ${({ $fullWidth }) => {

        return $fullWidth ? 0 : `${APP_SHELL_CONTENT_PADDING_Y}px ${APP_SHELL_CONTENT_PADDING_X} ${APP_SHELL_CONTENT_PADDING_BOTTOM}px`;
    }};
`;

module.exports = {
    AppShellContent: internals.AppShellContent,
    APP_SHELL_CONTENT_MAX_WIDTH: `${APP_SHELL_CONTENT_MAX_WIDTH}px`,
    APP_SHELL_CONTENT_PADDING_X,
    APP_SHELL_CONTENT_PADDING_Y: `${APP_SHELL_CONTENT_PADDING_Y}px`,
    APP_SHELL_CONTENT_PADDING_BOTTOM: `${APP_SHELL_CONTENT_PADDING_BOTTOM}px`
};
